class Lookbook extends HTMLElement {
    constructor() {
      super();
  
      this.modal = document.getElementById('lookbook-modal');
      this.clickedIndex = 0;
  
      const lookbookModalCloser = this.modal.querySelector('[js-modal-closer]');
      lookbookModalCloser?.addEventListener('click', (e) => {
        e.preventDefault();
        const target = e.target;
        const closeButton = this.modal.querySelector('[js-close-modal]');
  
        if (target.classList.contains('lookbook-modal-carousel-wrapper')) {
          closeButton.click();
        }
      });
  
      this._setupContinueReading();
      this._trackClickedIndex();
      this._setupModalHandlers();
      this._enableOutsideClickClose();
    }
  
    _setupContinueReading() {
      const button = this.querySelector('[js-continue-reading]');
      const description = this.querySelector('[js-description]');
  
      if (button && description) {
        button.addEventListener('click', () => {
          description.style.maxHeight = 'none';
          button.style.display = 'none';
        });
      }
    }
  
    _trackClickedIndex() {
      this.querySelectorAll('[js-open-modal]').forEach(item => {
        item.addEventListener('pointerdown', () => {
          const index = parseInt(item.dataset.index, 10);
          if (!isNaN(index)) {
            this.clickedIndex = index;
          }
        });
      });
    }
  
    _setupModalHandlers() {
      if (!this.modal) return;
  
      this.modal.addEventListener('open', () => {
        const swiperEl = this.modal.querySelector('.swiper');
        const index = this.clickedIndex;
    
        if (!swiperEl || isNaN(index)) return;
  
        const swiper = swiperEl.swiper;
  
        if (swiper) {
          swiper.slideTo(index);
          swiper.updateAutoHeight(0);
        } else {
          swiperEl.addEventListener(
            'init',
            () => {
              const instance = swiperEl.swiper;
              instance.slideTo(index);
              instance.updateAutoHeight(0);
            },
            { once: true }
          );
        }
      });
    }
  
    _enableOutsideClickClose() {
      const wrapper = this.modal.querySelector('.lookbook-modal-wrapper');
      if (!wrapper) return;
  
      wrapper.addEventListener('click', (e) => {
        const clickedInsideSlide = e.target.closest('.swiper-slide');
        const clickedInsideNav = e.target.closest('.swiper-button-prev, .swiper-button-next, .lookbook-modal-close');
        if (!clickedInsideSlide && !clickedInsideNav) {
          this.modal.dispatchEvent(new Event('close', { bubbles: true }));
        }
      });
    }     
  }
  
  customElements.define('look-book', Lookbook);
  